<template>
    <section class="item clearfix panel panel-default bg-white bg-gradient b b-light form-group">
        <div class="panel-body">
            <div class="row child-form">
                <div class="col-sm-12 m-b">
                    <input type="text" 
                        v-model="data.organization"
                        name="affiliation[affiliation_org][]"
                        data-required="true"
                        value=""
                        class="form-control parsley-validated"
                        placeholder="name of affiliated organization*">
                </div>
                <div class="col-sm-4 m-b">
                    <datepicker v-model="data.start_date" :minimumView="'month'" :maximumView="'year'" :initialView="'year'" :required="true" class="form-control datepicker-input-month start-date-monthly parsley-validated" :placeholder="'start date*'"></datepicker>
                </div>
                <div class="col-sm-4 m-b">
                    <datepicker v-model="data.end_date" :minimumView="'month'" :maximumView="'year'" :initialView="'year'" :aria-required="true" class="form-control datepicker-input-month end-date-monthly" aria-placeholder="end date"></datepicker>
                </div>
            </div>
        </div>
        <span class="pull-right btn btn-sm btn-light text-danger remove-item" @click="removeAffiliation"><i class="fa fa-minus"></i> remove</span>
    </section>
</template>

<script>

  import Datepicker from 'vuejs-datepicker';

    export default {
        components: {
          Datepicker
        },
        props: [
            'index',
            'data'
        ],
        model: {
            prop: 'data',
            event: 'updateAffiliation'
        },

        methods: {
            removeAffiliation() {
                this.$emit('remove-affiliation', this.index);
            }
        },
    }
</script>

<style lang="scss">
  .vdp-datepicker input {
    border: none;
  }
</style>
